module.exports = __webpack_public_path__ + "img/contact_phone_icon.1afb3415.svg";